<app-breadcrumb [items]="breadcrumbs"></app-breadcrumb>
<app-content-card cardTitle="Resultaten - Beeldvorming {{isCurrentSituation ? 'huidige' : 'toekomstige'}} situatie"  maxWidth="94vw" >
  @if (pdfExportIsCurrentSituation() === undefined) {
    <p>
      Deze pagina biedt het overzicht van de beoordeling van de items voor de {{isCurrentSituation ? 'huidige' : 'toekomstige'}} situatie per stakeholder.
      U kunt scrollen door zowel de rijen als de kolommen.
      De gemiddelde score wordt berekend op basis van alle stakeholders die een beoordeling van het item hebben gegeven (afgerond tot de likert-5 schaal van -- tot ++).
    <p>
    }
  @if (isCurrentSituation !== undefined) {
    <app-results-table
      [isCurrentSituation]="isCurrentSituation"
      [isPdfExport]="pdfExportIsCurrentSituation() !== undefined">
    </app-results-table>
  }
</app-content-card>
@if (pdfExportIsCurrentSituation() === undefined) {
  <app-save-warning-dialog-container />
}
